import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ESenderType } from '../../api/sendCode';
export var PHONE_CODE_SENDER_TO_LABEL = _defineProperty(_defineProperty({}, ESenderType.Sms, 'sms'), ESenderType.Call, 'last_phone_numbers');